import { SET_EDITED_PROFILE, SET_LOGIN_INFO, SET_PAYMENT_TYPE, SET_PLACE_INFO } from "./ActionTypes";
import { IReduxBaseAction } from '../types/ReduxBaseAction';

export function setLoginInfo(payload: any) {
    const action: IReduxBaseAction = {
        type: SET_LOGIN_INFO,
        payload: payload
    }
    return action;
}

export function setPlaceInfo(payload: any) {
    const action: IReduxBaseAction = {
        type: SET_PLACE_INFO,
        payload: payload
    }
    return action
}

export function setEditedProfile(payload: any) {
    const action: IReduxBaseAction = {
        type: SET_EDITED_PROFILE,
        payload: payload
    }
    return action
}

export function setPaymentType(payload: any) {
    const action: IReduxBaseAction = {
        type: SET_PAYMENT_TYPE,
        payload: payload
    }
    return action
}
/*

export function setIsShoppingBagLoading(payload: boolean) {
    const action: IReduxBaseAction = {
        type: SET_IS_SHOPPING_BAG_LOADING,
        payload: payload
    }
    return action
}*/
